<pdq-card variant="flat" color="white">
  <pdq-expandable-section [id]="sectionId" [cacheState]="true">
    <div sectionHeader>
      <div class="date-picker-profile__header" [class.disabled]="!formGroup.controls.enabled.value">
        <ng-content select="[dragHandle]"></ng-content>
        <pdq-heading element="h6">{{ formGroup.controls.name.value }}</pdq-heading>
      </div>
    </div>
    <div sectionHeaderActions class="date-picker-profile__actions">
      <pdq-slide-toggle
        [formControl]="formGroup.controls.enabled"
        (click)="$event.stopPropagation()"></pdq-slide-toggle>
      <pdq-button
        icon="trash"
        size="small"
        [plain]="true"
        variant="ghost-light"
        iconColor="var(--error-default)"
        (onClick)="remove.emit(); $event.stopPropagation()"></pdq-button>
    </div>

    <div class="date-picker-profile" [formGroup]="formGroup">
      <pdq-input
        label="Profile name"
        formControlName="name"
        placeholder="Date picker profile 1"
        [invalid]="formGroup.controls.name.dirty && formGroup.controls.name.errors?.duplicateName"
        [invalidMsg]="
          formGroup.controls.name.dirty && formGroup.controls.name.errors?.duplicateName
            ? 'A profile with this name already exists'
            : ''
        "></pdq-input>

      <div class="date-picker-profile__section">
        <pdq-date-picker-configuration
          [value]="formGroup.controls.configuration.value"
          (valueChange)="onDatePickerConfigChange($event)"></pdq-date-picker-configuration>
      </div>
    </div>
  </pdq-expandable-section>
</pdq-card>
